export default __webpack_public_path__ + "static/smb-tablet-dcbad5bf96dfa2d0b7d5f27014e015a1.png";